var it = {
  'Home': 'Home',
  'Contatti': 'Contatti',
  'Come trovare immobili': 'Come trovare immobili',
  'Vantaggi': 'Vantaggi',
  'Cerca': 'Cerca',
  'Case in vendita': 'Case in vendita',
  'di Nuova Costruzione': 'di Nuova Costruzione',
  'Proposte Direttamente dalle Imprese': 'Proposte Direttamente dalle Imprese',
  'I vantaggi': 'I vantaggi',
  'Risparmia tempo e denaro acquistando direttamente dai costruttori': 'Risparmia tempo e denaro acquistando direttamente dai costruttori',
  'Più informazioni': 'Più informazioni',
  'zona': 'zona',
  'mappa': 'Mappa',
  'cantieri': 'cantieri',
  'Altre proposte del costruttore': 'Altre proposte del costruttore',
  'Referenze del costruttore': 'Referenze del costruttore',
  'CANTIERI APERTI': 'CANTIERI APERTI',
  'CANTIERI ESEGUITI IN PASSATO': 'CANTIERI ESEGUITI IN PASSATO',
  'INFORMAZIONI SUL COSTRUTTORE': 'INFORMAZIONI SUL COSTRUTTORE',
  'Nessuna proposta disponibile per questo costruttore': 'Nessuna proposta disponibile per questo costruttore',
  rooms_extended: '0 camere | 1 camera | {rooms} camere',
  bathrooms_extended: '0 bagni | 1 bagno | {rooms} bagni',
  constructions_count: 'Nessun cantiere | 1 cantiere | {constructions_count} cantieri',
  construction: {
    construction_progress: {
      in_construction: 'In costruzione',
      completed: 'Finito',
      design_in_progress: 'In progettazione'
    }
  },
  app: {
    generals: {
      city: 'Città',
      state: 'Provincia'
    },
    privacy_policy: 'Presa visione dell\'informativa sulla privacy'
  },
  request_info_contact_info: 'La società <b>{contact_name}</b> riceverà una email con la tua richiesta di informazioni',
  typology_request_info_contact_info: 'Trovacantieri invierà una email alle società responsabili delle informazioni per la tipologia {typology_code}',
  typology_separator_images_preview: 'VEDI 0 IMMAGINI | VEDI 1 IMMAGINE | VEDI {images} IMMAGINI'
};
export default it;